import React, { Component } from "react";
import _ from "lodash";
import cx from "classnames";
import Select from "Components/simpleSelect/SimpleSelect";
import s from "./hourPicker.scss";

export default class HourPicker extends Component {
  constructor(props) {
    super(props);
    this.composeFullHour = this.composeFullHour.bind(this);
    this.reset = this.reset.bind(this);

    let hourOptions = _.times(24, i => {
      const value = i < 10 ? `0${i}` : `${i}`;
      return {
        value,
        label: value
      };
    });

    let minuteOptions;
    if (!props.minutesOptions) {
      minuteOptions = [{ label: "00", value: 0 }, { label: "30", value: 30 }];

      // minuteOptions = _.times(60, i => {
      //   const value = i < 10 ? `0${i}` : `${i}`;
      //   return {
      //     value,
      //     label: value
      //   };
      // });
    } else {
      minuteOptions = props.minutesOptions;
    }

    if (props.resettable) {
      hourOptions = [{ value: "-", label: "-" }, ...hourOptions];
      minuteOptions = [{ value: "-", label: "-" }, ...minuteOptions];
    }

    this.state = {
      hours: hourOptions,
      minutes: minuteOptions
    };
  }

  reset() {
    this.props.onChange({ [this.props.name]: "-:-" });
  }

  scomposeFullHour(fullHour) {
    return fullHour.split(":");
  }

  getMinutes(fullHour) {
    return this.scomposeFullHour(fullHour)[1];
  }

  getHours(fullHour) {
    return this.scomposeFullHour(fullHour)[0];
  }

  composeFullHour(values) {
    const { value } = this.props;
    const isResettingAField = _.values(values)[0] === "-";

    let composedHour;
    if (value !== "-:-" && isResettingAField) {
      composedHour = "-:-";
    } else {
      const isEditingHour = Object.keys(values).includes("hour");
      if (isEditingHour) {
        let minute = this.getMinutes(value);
        if (minute === "-") {
          minute = "00";
        }
        composedHour = `${values.hour}:${minute}`;
      } else {
        // is editing minute
        let hour = this.getHours(value);
        if (hour === "-") {
          hour = "00";
        }
        composedHour = `${hour}:${values.minute}`;
      }
    }

    this.props.onChange({ [this.props.name]: composedHour });
  }

  render() {
    const {
      className,
      label,
      errors,
      value,
      hint,
      name,
      disabled,
      noLabel,
      resettable
    } = this.props;
    const hasAValue = value !== "-:-";
    return (
      <div className={cx(className, s.hourPicker, { [s.withErrors]: errors })}>
        {label && (
          <label className={s.label} htmlFor={name}>
            {label || name.replace(/_/g, " ")}
          </label>
        )}
        <div className={s.wrapSelect}>
          <Select
            className={s.select}
            options={this.state.hours}
            name="hour"
            required
            noLabel
            immutableOptions
            disabled={disabled}
            value={this.getHours(value)}
            onChange={this.composeFullHour}
          />
          <div className={s.hoursDivider}>&#58;</div>

          <Select
            className={s.select}
            options={this.state.minutes}
            name="minute"
            required
            noLabel
            immutableOptions
            disabled={disabled}
            value={this.getMinutes(value)}
            onChange={this.composeFullHour}
          />
        </div>
        {hasAValue && resettable && (
          <div className={s.resetBtn} onClick={this.reset}>
            Reset
          </div>
        )}
        <span>{errors && errors}</span>
      </div>
    );
  }
}

HourPicker.defaultProps = {
  value: "-:-"
};
